export default __webpack_public_path__ + "static/media/data.5417c619.svg";